export default __webpack_public_path__ + "static/media/portraitLarge.fef316b4.jpg";